import { useCallback, useContext, useState } from 'react';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { UserContext } from '@namespace/user';
import { bonusesActions } from '../../store';

const {
  FETCH_ALL_TYPES_BONUSES_HISTORY,
  FETCH_MORE_ALL_TYPES_BONUSES_HISTORY
} = bonusesActions;

export const useAllTypesBonusesHistoryFetchCallbacks = () => {
  const { t } = useI18n();
  const [page, setPage] = useState(1);
  const [isFetchingBonuses, setIsFetchingBonuses] = useState(true);
  const [isFetchingMoreBonuses, setIsFetchingMoreBonuses] = useState(false);
  const { errorNotification } = useNotifications();

  const [user] = useContext(UserContext);
  const { activeWallet } = user;
  const { currency } = activeWallet;

  const loadBonusesHistoryList = useCallback(async () => {
    setIsFetchingBonuses(true);
    setPage(1);
    try {
      await FETCH_ALL_TYPES_BONUSES_HISTORY({ currency });
    } catch {
      errorNotification(t(`accountingMessages.accounting_error_6`));
    } finally {
      setIsFetchingBonuses(false);
    }
  }, [currency, errorNotification, t]);

  const loadMoreBonusesHistoryList = useCallback(async () => {
    try {
      setIsFetchingMoreBonuses(true);
      await FETCH_MORE_ALL_TYPES_BONUSES_HISTORY({ page: page + 1, currency });
      setPage((prevState) => prevState + 1);
    } catch {
      errorNotification(t(`accountingMessages.accounting_error_6`));
    } finally {
      setIsFetchingMoreBonuses(false);
    }
  }, [currency, errorNotification, page, t]);

  return {
    loadBonusesHistoryList,
    loadMoreBonusesHistoryList,
    isFetchingBonuses,
    isFetchingMoreBonuses
  };
};
